<div class="flex-row">
    <ng-container
        *ngrxLet="currentHierarchicalSelectionRootName$ as currentHierarchicalSelectionRootName"
    >
        <ng-container *ngrxLet="getHasSavedSelections() as hasSavedSelections">
            <button
                (click)="downloadHierarchicalSelections()"
                [disabled]="!currentHierarchicalSelectionRootName"
                class="icon-button"
                [attr.aria-label]="'Download hierarchical selections'"
                [title]="
                    currentHierarchicalSelectionRootName
                        ? 'Download hierarchical selections for dataset in JSON format'
                        : 'No data available for download'
                "
            >
                <cds-icon shape="download"></cds-icon>
            </button>
            <cds-select layout="vertical" controlWidth="stretch">
                <label
                    >Saved
                    {{
                        isUnsupervisedSelection ? 'unsupervised' : 'hierarchical'
                    }}
                    selections</label
                >
                <select
                    name="hierarchical-selection-roots"
                    class="selection-root-select"
                    [ngModel]="currentHierarchicalSelectionRootName"
                    (ngModelChange)="setSelection($event)"
                    [disabled]="!hasSavedSelections"
                >
                    <option selected style="display: none"></option>
                    <ng-container *ngFor="let name of savedHierarchicalSelectionNames$ | async">
                        <option [ngValue]="name">{{ name }}</option>
                    </ng-container>
                </select>
            </cds-select>
            <ng-container *ngrxLet="isSharedCase$ as isSharedCase">
                <cds-button
                    size="sm"
                    action="outline"
                    [disabled]="
                        isSharedCase ||
                        !(currentSegObjectPropertyMap$ | async) ||
                        isUnsupervisedSelection
                    "
                    (click)="createNewHierarchicalSelectionRoot()"
                >
                    Create new
                </cds-button>
                <button
                    size="sm"
                    [disabled]="!currentHierarchicalSelectionRootName || isSharedCase"
                    (click)="
                        deleteCurrentHierarchicalSelectionRoot(currentHierarchicalSelectionRootName)
                    "
                    class="icon-button"
                >
                    <cds-icon shape="trash"></cds-icon>
                </button>
            </ng-container>
        </ng-container>
    </ng-container>
</div>
